module.exports = "<div class=\"row\">\n  <div class=\"col s12\">\n    <h6 class=\"center big-text\">Mouvements</h6>\n\n    <canvas id=\"movementPie\"\n      class=\"chart chart-line\"\n      chart-data=\"data\"\n      chart-labels=\"labels\"\n      chart-series=\"series\">\n    </canvas>\n  </div>\n</div>\n"


//////////////////
// WEBPACK FOOTER
// ./public/javascript/sygem/global/directives/stat/myMovementsPie.html
// module id = 1273
// module chunks = 0